import { render, staticRenderFns } from "./indextwo.vue?vue&type=template&id=0281620d&scoped=true&"
import script from "./indextwo.vue?vue&type=script&lang=js&"
export * from "./indextwo.vue?vue&type=script&lang=js&"
import style0 from "./indextwo.vue?vue&type=style&index=0&id=0281620d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281620d",
  null
  
)

export default component.exports